<template>
    <div style="min-height: 400px;">
        <b-row>
            <b-col cols="12">
                <h4> Parser </h4>
                <div>
                    {{ sub_code }} / {{ sub_type }}
                </div>
            </b-col>
        </b-row>
        <b-row v-show="!notSupportSubsType">
            <b-col cols="12">
                <hr>
            </b-col>
        </b-row>
        <b-row v-show="!notSupportSubsType" class="">
            <b-col cols="12" class="">
                <h5 class="mb-1"> Preview </h5>
                <div class="border rounded h-100" style="max-height: 200px;overflow-y: auto;">
                    <pre class="p-3">{{ sub_data_contents }}</pre>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <hr>
            </b-col>
            <b-col cols="12" v-if="sub_type === 'radio'">
                <b-table-simple class="my-0" :id="`subs-${sub_type}-parser-table`" bordered>
                    <b-thead>
                        <b-tr class="gray-500">
                            <b-th colspan="4">sub_type: {{ sub_type }}</b-th>
                        </b-tr>
                        <b-tr class="gray-500 bgray-200">
                            <b-th> index </b-th>
                            <b-th> text </b-th>
                            <b-th> value </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <template v-for="(structure, s_idx) in sub_data_contents.structure">
                            <b-tr v-if="!isFieldEmpty(structure)"
                                :key="`subs-${sub_type}-parser-table-structure-${s_idx}`">
                                <b-td :rowspan="isFieldEmpty(structure.element_contents) ? 1 : 2" class="bgray-200">
                                    <div>{{ s_idx }}</div>
                                </b-td>
                                <b-td
                                    :class="['gray-700', { 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                    @click="criteria_picker_non_element(s_idx, 1, 'result', !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea))">
                                    <div>{{ structure.text }}</div>
                                </b-td>
                                <b-td
                                    :class="['gray-700', { 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                    @click="criteria_picker_non_element(s_idx, 2, 'result', !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea))">
                                    <div>{{ structure.value }}</div>
                                </b-td>
                            </b-tr>
                            <template v-if="!isFieldEmpty(structure.element_contents)">
                                <b-tr :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_contents`">
                                    <b-td colspan="4">
                                        <b-table-simple v-for="(element_content, ec_idx) in structure.element_contents"
                                            :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_content-${ec_idx}`"
                                            :class="['my-0', { 'my-2': element_content.type }]" bordered>
                                            <template
                                                v-if="['input_text', 'input_number'].includes(element_content.type)">
                                                <b-thead>
                                                    <b-tr class="bgray-200 gray-500">
                                                        <b-th colspan="4">
                                                            sub_type: {{ element_content.type }}
                                                        </b-th>
                                                    </b-tr>
                                                    <b-tr class="bgray-200 gray-500">
                                                        <b-th> index </b-th>
                                                        <b-th> 구분 </b-th>
                                                        <b-th> 답변 </b-th>
                                                        <template v-if="element_content.type === 'input_number'">
                                                            <b-th> 단위 </b-th>
                                                        </template>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr>
                                                        <b-td class="bgray-200">
                                                            <div>{{ ec_idx }}</div>
                                                        </b-td>
                                                        <b-td
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                ec_idx,
                                                                1,
                                                                element_content.structure.pre_text,
                                                                '구분',
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <div>{{ element_content.structure.pre_text }}</div>
                                                        </b-td>
                                                        <b-td
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                ec_idx,
                                                                2,
                                                                element_content.structure.placeholder,
                                                                '답변',
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <div class="gray-500">
                                                                <template
                                                                    v-if="!isFieldEmpty(element_content.structure.placeholder)">
                                                                    ({{ element_content.structure.placeholder }})
                                                                </template>
                                                                <template v-else>
                                                                    -
                                                                </template>
                                                            </div>
                                                        </b-td>
                                                        <template v-if="element_content.type === 'input_number'">
                                                            <b-td
                                                                :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                                @click="criteria_picker_element(
                                                                    element_content.type,
                                                                    s_idx,
                                                                    null,
                                                                    ec_idx,
                                                                    3,
                                                                    element_content.structure.after_text,
                                                                    '단위',
                                                                    !(!isEditorActivated && !activateAllClickableArea)
                                                                )">
                                                                <template
                                                                    v-if="!isFieldEmpty(element_content.structure.after_text)">
                                                                    {{ element_content.structure.after_text }}
                                                                </template>
                                                                <template v-else>
                                                                    -
                                                                </template>
                                                            </b-td>
                                                        </template>
                                                    </b-tr>
                                                </b-tbody>
                                            </template>
                                            <template v-else-if="element_content.type === 'checkbox'">
                                                <b-thead>
                                                    <b-tr class="bgray-200 gray-500">
                                                        <b-th colspan="4">sub_type: {{ element_content.type }}</b-th>
                                                    </b-tr>
                                                    <b-tr class="bgray-200 gray-500">
                                                        <b-th> index </b-th>
                                                        <b-th> text </b-th>
                                                        <b-th> value </b-th>
                                                        <b-th> description </b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(structure, ele_str_idx) in element_content.structure"
                                                        :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_content-checkbox-${ec_idx}-${ele_str_idx}`">
                                                        <b-td class="bgray-200">{{ ele_str_idx }}</b-td>
                                                        <b-td
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                ec_idx,
                                                                1,
                                                                structure.text,
                                                                'text',
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <div> {{ structure.text }} </div>
                                                        </b-td>
                                                        <b-td
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                ec_idx,
                                                                2,
                                                                structure.value,
                                                                'value',
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <div> {{ structure.value }} </div>
                                                        </b-td>
                                                        <b-td
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }, 'gray-500']"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                ele_str_idx,
                                                                ec_idx,
                                                                structure.description,
                                                                'description',
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <template v-if="!isFieldEmpty(structure.placeholder)">
                                                                ({{ structure.placeholder }})
                                                            </template>
                                                            <template v-else>
                                                                -
                                                            </template>
                                                        </b-td>
                                                    </b-tr>
                                                </b-tbody>
                                            </template>
                                            <template v-else-if="element_content.type === 'table'">
                                                <b-thead>
                                                    <tr class="gray-500">
                                                        <b-th :colspan="element_content.table_header.length + 1">
                                                            sub_type: {{ element_content.type }}
                                                        </b-th>
                                                    </tr>
                                                    <b-tr class="gray-500">
                                                        <b-th> Index </b-th>
                                                        <b-th v-for="(header, th_idx) in element_content.table_header"
                                                            :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_content-table-${ec_idx}-structure-header-${th_idx}`">
                                                            {{ header }}
                                                        </b-th>
                                                    </b-tr>
                                                </b-thead>
                                                <b-tbody>
                                                    <b-tr v-for="(structure, str_idx) in element_content.structure"
                                                        :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_content-table-${ec_idx}-structure-body-${str_idx}`">
                                                        <b-td>
                                                            {{ str_idx }}
                                                        </b-td>
                                                        <td v-for="(col, col_idx) in element_content.table_header"
                                                            :key="`subs-${sub_type}-parser-table-structure-${s_idx}-element_content-table-${ec_idx}-structure-body-${str_idx}-col-${col_idx}`"
                                                            :class="[{ 'bgray-100': !isEditorActivated && !activateAllClickableArea }]"
                                                            @click="criteria_picker_element(
                                                                element_content.type,
                                                                s_idx,
                                                                null,
                                                                str_idx,
                                                                ec_idx,
                                                                structure[col] === '' || !structure[col] ? null : structure[col],
                                                                element_content.table_header[col_idx],
                                                                !(!isEditorActivated && !activateAllClickableArea)
                                                            )">
                                                            <template v-if="isFieldEmpty(structure[col])">
                                                                <div
                                                                    v-show="structure.dropdown[element_content.table_header[col_idx]]">
                                                                    {{ structure.dropdown[element_content.table_header[col_idx]] }}
                                                                </div>
                                                                <div v-show="structure.placeholder[element_content.table_header[col_idx]]"
                                                                    class="gray-550">
                                                                    ({{
                                                                        structure.placeholder[element_content.table_header[col_idx]]
                                                                    }})
                                                                </div>
                                                                <div
                                                                    v-show="!structure.placeholder[element_content.table_header[col_idx]] && !structure.dropdown[element_content.table_header[col_idx]]">
                                                                    -
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                {{ structure[col] }}
                                                            </template>
                                                        </td>
                                                    </b-tr>
                                                </b-tbody>
                                            </template>
                                        </b-table-simple>
                                    </b-td>
                                </b-tr>
                            </template>
                        </template>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col cols="12" v-else-if="sub_type === 'checkbox'">
                <b-table-simple class="my-0" :id="`subs-${sub_type}-parser-table`" bordered>
                    <b-thead>
                        <b-tr class="bgray-200 gray-500">
                            <b-th colspan="4">sub_type: {{ sub_type }}</b-th>
                        </b-tr>
                        <b-tr class="bgray-200 gray-500">
                            <b-th> index </b-th>
                            <b-th> text </b-th>
                            <b-th> value </b-th>
                            <b-th> input </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <template v-for="(structure, s_idx) in sub_data_contents.structure">
                            <b-tr v-if="!isFieldEmpty(structure)"
                                :key="`subs-${sub_type}-parser-table-structure-${s_idx}`">
                                <b-td class="bgray-200">
                                    <div>{{ s_idx }}</div>
                                </b-td>
                                <b-td
                                    :class="['gray-700', { 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                    @click="criteria_picker_non_element(s_idx, 1, 'result', !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea))">
                                    <div>{{ structure.text }}</div>
                                </b-td>
                                <b-td
                                    :class="['gray-700', { 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                    @click="criteria_picker_non_element(s_idx, 2, 'result', !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea))">
                                    <div>{{ structure.value }}</div>
                                </b-td>
                                <b-td
                                    :class="['gray-500', { 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                    @click="criteria_picker_non_element(s_idx, 3, 'description', !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea))">
                                    <div v-show="isFieldEmpty(structure.placeholder)">-</div>
                                    <div v-show="!isFieldEmpty(structure.placeholder)">({{ structure.placeholder }})
                                    </div>
                                </b-td>
                            </b-tr>
                        </template>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col cols="12" v-else-if="sub_type === 'table'">
                <b-table-simple class="my-0" :id="`subs-${sub_type}-parser-table`" bordered>
                    <b-thead>
                        <b-tr class="bgray-200">
                            <b-th :colspan="sub_data_contents.table_header.length + 1">
                                sub_type: {{ sub_type }}
                            </b-th>
                        </b-tr>
                        <b-tr class="bgray-200">
                            <b-th> Index </b-th>
                            <b-th v-for="(header, th_idx) in sub_data_contents.table_header"
                                :key="`subs-${sub_type}-parser-table-structure-header-${th_idx}`">
                                {{ header }}
                            </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr v-for="(structure, td_idx) in sub_data_contents.structure"
                            :key="`subs-${sub_type}-parser-table-structure-body-${td_idx}`">
                            <b-th class="bgray-200">
                                {{ td_idx }}
                            </b-th>
                            <b-td v-for="(header, th_idx) in sub_data_contents.table_header"
                                :key="`subs-${sub_type}-parser-table-structure-body-${td_idx}-col-${th_idx}`"
                                :class="[{ 'bgray-100': (!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea }]"
                                @click="criteria_picker_non_element(
                                    td_idx,
                                    th_idx,
                                    header,
                                    !((!isEditorActivated || !isFieldEmpty(structure.element_contents)) && !activateAllClickableArea)
                                )">
                                <div v-show="structure[header]"> {{ structure[header] }} </div>
                                <div v-show="structure.dropdown[header]"> {{ structure.dropdown[header] }} </div>
                                <div v-show="structure.placeholder[header]" class="gray-500"> ({{
                                    structure.placeholder[header] }})
                                </div>
                                <div v-show="!structure[header] && !structure.dropdown[header] && !structure.placeholder[header]"
                                    class="gray-500 text-center"> - </div>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col v-else>
                <b-table-simple class="bgray-100 my-0" :id="`subs-${sub_type}-parser-table`" bordered>
                    <b-thead>
                        <b-tr>
                            <b-th colspan="2"> sub_type: {{ sub_type }} </b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr>
                            <b-td class="gray-600 font-italic"> (미지원 유형입니다.) </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <hr>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12">
                <b-card id="parser_editor" no-body class="mb-3">
                    <b-card-header class="d-flex justify-content-between align-items-start">
                        <div>
                            <h5 class="">Parser 생성/편집기</h5>
                            <h6 class="mb-0">
                                <b-badge variant="info" title="Criteria Id" class="font-weight-normal mr-2" pill>
                                    Subs Id: {{ sub_code }}
                                </b-badge>
                                <b-badge variant="warning" title="Sub Component 유형" class="font-weight-normal mr-2"
                                    pill>
                                    서브 컴포넌트: {{ sub_type }}
                                </b-badge>
                            </h6>
                        </div>
                        <div class="text-right">
                            <div>
                                <b-btn :pressed.sync="isEditorActivated" variant="primary" size="sm" class="mr-2"
                                    :disabled="notSupportSubsType">
                                    {{ !isEditorActivated ? '켜기' : '끄기' }}
                                </b-btn>
                                <b-btn size="sm" variant="warning" class="mr-2"
                                    @click="activateAllClickableArea = !activateAllClickableArea"
                                    :disabled="notSupportSubsType || !isEditorActivated">
                                    전체 영역 {{ activateAllClickableArea ? '비활성화' : '활성화' }} 하기
                                </b-btn>
                            </div>
                            <div class="bg-danger text-light px-2 py-1 small rounded mt-2"
                                v-show="activateAllClickableArea">
                                ▶ 잘못된 영역이 선택될 수 있을을 알려드립니다.
                            </div>
                        </div>
                    </b-card-header>
                    <b-card-body class="pt-3">
                        <b-form @submit.prevent="onCreateCriteriaDefinition" @reset="onResetParser">
                            <b-form-row class="align-items-end mb-3">
                                <b-col cols="4">
                                    <b-form-group id="input-group-item_selected" label="측정 항목"
                                        label-for="input-item_selected" class="mb-0">
                                        <b-form-select id="input-item_selected" v-model="definitionForm.item_selected"
                                            :options="criteriaDictionaries" placeholder="측정 항목을 선택해주세요"
                                            text-field="criteria_name" value-field="id"
                                            :disabled="!isEditorActivated || notSupportSubsType" required />
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group id="input-group-item_index" label="Index" label-for="input-item_index"
                                        class="mb-0">
                                        <b-form-input id="input-item_index" :value="definitionForm.item_index" required
                                            disabled readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6" lg="3">
                                    <b-form-group id="input-group-item_key" label="Key" label-for="input-item_key"
                                        class="mb-0">
                                        <b-form-input id="input-item_key" :value="definitionForm.item_key" required
                                            disabled readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6" lg="2">
                                    <b-btn
                                        :class="['h-100', { 'bgray-300': !is_Activate_Picker_Key || !isEditorActivated }]"
                                        :variant="is_Activate_Picker_Key && isEditorActivated ? 'primary' : 'bgray-300'"
                                        @click="setActivate_Picker('key')"
                                        :disabled="!isEditorActivated || is_create_criteria_definition || is_delete_criteria_definition || notSupportSubsType"
                                        block pill>
                                        항목 선택
                                    </b-btn>
                                </b-col>
                            </b-form-row>
                            <b-form-row class="align-items-end mb-2">
                                <b-col cols="4">
                                    <b-form-group id="input-group-unit" label="단위" label-for="input-unit" class="mb-0">
                                        <b-form-input id="input-unit" v-model="definitionForm.unit_static_value"
                                            type="text" placeholder="값으로 지정 (직접 입력)"
                                            :disabled="(!isUnitInputStaticValue && !isUnitInputAndPickStaticValue) || !isEditorActivated || !is_Activate_Picker_Unit || notSupportSubsType"
                                            trim />
                                    </b-form-group>
                                </b-col>
                                <b-col lg="3">
                                    <b-form-group id="input-group-unit_index" label="Index" label-for="input-unit_index"
                                        class="mb-0">
                                        <b-form-input id="input-unit_index" :value="definitionForm.unit_index"
                                            placeholder="" required
                                            :disabled="!isEditorActivated || isUnitInputStaticValue || notSupportSubsType"
                                            readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6" lg="3">
                                    <b-form-group id="input-group-unit_key" label="Key" label-for="input-unit_key"
                                        class="mb-0">
                                        <b-form-input id="input-unit_key" :value="definitionForm.unit_key"
                                            placeholder="subs 단위" required
                                            :disabled="!isEditorActivated || isUnitInputStaticValue || notSupportSubsType"
                                            readonly />
                                    </b-form-group>
                                </b-col>
                                <b-col cols="6" lg="2">
                                    <b-btn class="h-100"
                                        :class="['h-100', { 'bgray-300': !is_Activate_Picker_Unit || !isEditorActivated }]"
                                        :variant="is_Activate_Picker_Unit ? 'primary' : 'bgray-300'"
                                        @click="setActivate_Picker('unit')"
                                        :disabled="!isEditorActivated || is_create_criteria_definition || is_delete_criteria_definition || notSupportSubsType"
                                        block pill>
                                        단위 선택
                                    </b-btn>
                                </b-col>
                            </b-form-row>
                            <b-form-row>
                                <b-col cols="4">
                                    <b-form-group id="input-group-year" label="연도" label-for="input-year">
                                        <b-input-group prepend="FY">
                                            <b-form-input id="input-year" type="number" v-model="definitionForm.year"
                                                :disabled="!isEditorActivated || notSupportSubsType" placeholder="직접 입력"
                                                :max="year_max" required />
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group id="input-group-collection_year" label="데이터 수집 연도"
                                        label-for="input-collection_year">
                                        <b-input-group>
                                            <b-form-input id="input-collection_year" type="number"
                                                v-model="definitionForm.collection_year"
                                                :disabled="!isEditorActivated || notSupportSubsType" placeholder="직접 입력"
                                                :max="year_max" required />
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="4">
                                    <b-form-group id="input-group-measure_type" label="측정 용도"
                                        label-for="input-measure_type">
                                        <b-form-select id="input-measure_type" v-model="definitionForm.measure_type"
                                            :options="measure_types" />
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <b-form-row class="mb-3">
                                <b-col cols="12" md>
                                    <b-card v-show="isUnitInputStaticValue || isUnitInputAndPickStaticValue"
                                        bg-variant="warning" class="text-dark">
                                        <div v-show="isUnitInputStaticValue">
                                            ▶ {{ definitionForm.type }} 타입의 subs는 <strong class="font-italic">"단위"를 직접
                                                입력하거나
                                                생략할</strong> 수 있습니다.
                                        </div>
                                        <div v-show="isUnitInputAndPickStaticValue">
                                            ▶ {{ definitionForm.type }} 타입의 subs는 <strong class="font-italic">직접 입력한
                                                "단위" 또는 위에서
                                                선택한 "단위"가 적용 </strong> 됩니다.
                                            <br />
                                            ▶ {{ definitionForm.type }} 타입의 subs는 <strong class="font-italic">"단위"를 직접
                                                입력할 경우,
                                                선택한 단위는 적용되지 않습니다.</strong>
                                            <br />
                                            ▶ <strong class="font-italic">"단위"를 선택 또는 직접 입력하지 않을 경우, </strong> "단위"가
                                            생략된채로 처리됩니다
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-form-row>
                            <b-form-row class="align-items-center">
                                <b-col cols="12" class="text-right">
                                    <b-btn type="submit" variant="primary" class="h-100 mr-2"
                                        :disabled="notSupportSubsType">
                                        저장
                                        <b-spinner v-show="is_create_criteria_definition"
                                            :disabled="is_create_criteria_definition" small />
                                    </b-btn>
                                    <b-btn type="reset" variant="danger" class="h-100"
                                        :disabled="is_create_criteria_definition || notSupportSubsType">
                                        취소
                                    </b-btn>
                                </b-col>
                            </b-form-row>
                        </b-form>
                    </b-card-body>
                </b-card>
            </b-col>
            <b-col cols="12" class="text-right mb-3">
                <b-btn @click="is_opened_criteria_definition = !is_opened_criteria_definition" variant="secondary"
                    size="sm" class="mr-2">
                    해당 Subs의 Definition 목록 {{ !is_opened_criteria_definition ? '보기' : '숨기기' }} - ({{
                        criteriaDefinitions.length
                    }} 개)
                </b-btn>
                <b-button id="btn-criteria-parse-values" class="fw-500" variant="secondary" size="sm"
                    @click="parseCriteriaDefinition"
                    :disabled="is_parsing_criteriaDefinition.progress || !criteriaDefinitions.length">
                    데이터 파싱 및 저장
                    <b-spinner v-show="is_parsing_criteriaDefinition.progress" size="sm" small class="ml-1" />
                </b-button>
                <div v-show="is_parsing_criteriaDefinition.success !== null">
                    <div :class="[
                        'd-inline-block rounded small px-2 py-1 my-2',
                        { 'bg-warning text-dark': is_parsing_criteriaDefinition.success === false },
                        { 'bg-primary text-light': is_parsing_criteriaDefinition.success === true },
                    ]">
                        파싱 및 저장을
                        <span v-show="is_parsing_criteriaDefinition.success === true">'성공하였습니다.'</span>
                        <span v-show="is_parsing_criteriaDefinition.success === false">'실패하였습니다. 개발팀에게 문의해주세요.'</span>
                    </div>
                </div>
            </b-col>
            <b-col cols="12">
                <b-collapse v-model="is_opened_criteria_definition" id="collapse-criteria-definition-table">
                    <b-card no-body class="mb-3" id="criteria-definition-table-card">
                        <b-card-header class="d-flex justify-content-between align-items-end">
                            <h5 class="mb-0">Subs:{{ sub_code }} Criteria Definition 목록</h5>
                            <b-btn variant="secondary" size="sm"
                                @click="is_opened_criteria_definition = !is_opened_criteria_definition">
                                {{ !is_opened_criteria_definition ? '보기' : '숨기기' }}
                            </b-btn>
                        </b-card-header>

                        <b-table :items="criteriaDefinitions" :fields="criteriaDefinition_fields" striped hover
                            no-border-collapse empty-text="생성된 criteria definition이 없습니다." show-empty
                            table-class="border-left border-right mb-0" sticky-header="250" details-td-class="bg-white">

                            <template #empty="scope">
                                <h6 class="font-italic gray-600 font-weight-normal text-center">{{ scope.emptyText }}
                                </h6>
                            </template>

                            <template #cell(criteria_id)="data">
                                <div style="max-width: 150px;">
                                    {{ data.item.criteria_name }} ({{ data.value }})
                                </div>
                            </template>

                            <template #row-details="row">
                                <b-table-simple hover small caption-top responsive>
                                    <caption>Criteria 적용요소 위치</caption>
                                    <b-thead head-variant="dark">
                                        <b-tr>
                                            <b-th>structure_idx</b-th>
                                            <b-th>element_idx</b-th>
                                            <b-th>element_str_idx</b-th>
                                            <b-th>key</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-td>{{ row.item.structure_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.element_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.element_str_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.key || '-' }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>

                                <b-table-simple hover small caption-top responsive>
                                    <caption>단위</caption>
                                    <b-thead head-variant="dark">
                                        <b-tr>
                                            <b-th>unit_structure_idx</b-th>
                                            <b-th>unit_element_idx</b-th>
                                            <b-th>unit_element_str_idx</b-th>
                                            <b-th>unit_key</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-td>{{ row.item.unit_structure_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.unit_element_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.unit_element_str_idx || '-' }}</b-td>
                                            <b-td>{{ row.item.unit_key || '-' }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>

                                <b-table-simple hover small caption-top responsive>
                                    <caption>기타</caption>
                                    <b-thead head-variant="dark">
                                        <b-tr>
                                            <b-th>unit_static_value</b-th>
                                            <b-th>year</b-th>
                                            <b-th>collection_year</b-th>
                                            <b-th>type</b-th>
                                        </b-tr>
                                    </b-thead>
                                    <b-tbody>
                                        <b-tr>
                                            <b-td>{{ row.item.unit_static_value }}</b-td>
                                            <b-td>{{ row.item.year }}</b-td>
                                            <b-td>{{ row.item.collection_year }}</b-td>
                                            <b-td>{{ row.item.type }}</b-td>
                                        </b-tr>
                                    </b-tbody>
                                </b-table-simple>
                            </template>

                            <template #cell(definition_control)="data">
                                <b-btn variant="primary" class="mr-2"
                                    @click="editCriteriaDefinition(data.index, data.item.definition_id, data.item.criteria_id)"
                                    size="sm"
                                    :disabled="is_create_criteria_definition || is_delete_criteria_definition">
                                    수정
                                </b-btn>
                                <b-btn variant="danger" class="mr-2"
                                    @click="deleteCriteriaDefinition(data.item.definition_id, data.item)" size="sm"
                                    :disabled="is_create_criteria_definition || is_delete_criteria_definition">
                                    <!-- @click="deleteCriteriaDefinition(data.item.definition_id)" -->
                                    삭제
                                    <b-spinner
                                        v-show="is_delete_criteria_definition && delete_criteria_definition_target === data.item.definition_id"
                                        small />
                                </b-btn>
                            </template>

                            <template #cell(show_details)="row">
                                <b-btn @click="row.toggleDetails" size="sm">
                                    {{ row.detailsShowing ? '▲' : '▼' }}
                                </b-btn>
                            </template>
                        </b-table>
                    </b-card>
                </b-collapse>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { getErrorMessage } from '@core/utils/api/errorMessage';
export default {
    name: 'EditingSubsPickerParser',
    props: {
        sub_code: {
            type: String,
            default: ''
        },
        sub_type: {
            type: String,
            default: ''
        },
        sub_data_contents: {
            type: Object
        }
    },
    data() {
        return {
            activateAllClickableArea: false, // 전체 영역 활성화 상태조정 variable
            isEditorActivated: false,
            // criteria definition 관련 action status
            is_opened_criteria_definition: false,
            is_create_criteria_definition: false,
            is_delete_criteria_definition: false,
            criteriaDictionaries: [],
            criteriaDefinitions: [],
            is_Activate_Picker_Key: true,
            is_Activate_Picker_Unit: false,
            measure_types: [
                { text: 'Figure', value: 'figure' },
                { text: 'MYSC', value: 'mysc' }
            ],
            definitionForm: {
                id: null,
                type: null, // 'radio', 'checkbox', 'table', 'file_URL2', 'textbox'
                item_selected: null,
                item_index: null, // 측정항목 Structure Index
                item_key: null,
                item_element_content_structure_index: null,
                item_element_content_index: null,
                unit_index: null, // 단위 Unit Structure Index
                unit_key: null,
                unit_static_value: null,
                unit_element_content_structure_index: null,
                unit_element_content_index: null,
                year: null,
                collection_year: null,
                measure_type: 'figure'
            },
            criteriaDefinition_fields: [
                {
                    key: 'definition_id',
                    label: 'Id',
                    sortable: false
                },
                {
                    key: 'sub_code',
                    label: 'Subs Id',
                    sortable: false
                },
                {
                    key: 'criteria_id',
                    label: '측정항목 이름 (Criteria Id)',
                    sortable: false
                },
                {
                    key: 'definition_control',
                    label: '수정 및 삭제',
                    sortable: false
                },
                {
                    key: 'show_details',
                    label: '상세보기',
                    sortable: false
                }
            ],
            // criteria definition 관련 target element indicator
            delete_criteria_definition_target: null,
            year_max: null,
            is_parsing_criteriaDefinition: {
                progress: false,
                success: null
            }
        }
    },
    computed: {
        isUnitInputStaticValue() {
            const notUseUnitForm = ['input_text', 'checkbox'].includes(this.definitionForm.type)
            return notUseUnitForm
        },
        isUnitInputAndPickStaticValue() {
            return ['input_number'].includes(this.definitionForm.type)
        },
        notSupportSubsType() {
            return ['file_URL2', 'textbox', 'guide_text'].includes(this.sub_type)
        }
    },
    watch: {},
    async created() {
        this.definitionForm.year = new Date().getFullYear()
        this.definitionForm.collection_year = new Date().getFullYear()
        this.year_max = new Date().getFullYear()

        /**
         * getCriteriaDictionaries 메서드
         *   - criteria dictionary 읽어오는 API - '/criteria/dictionaries'
         * getCriteriaDefinitions 메서드
         *   - sub_code에 등록된 criteria definition 읽어오는 API - '/criteria/definitions/<sub_code>'
         * 
         * 위와 관련된 API가 완성되면 메서드 line 902, 902 에 주석처리된 code를 활성화 하고 created 훅(hook) 앞에 async를 붙여주면 됨.
         */
        await this.getCriteriaDictionaries()
        await this.getCriteriaDefinitions()
    },
    mounted() { },
    methods: {
        async getCriteriaDictionaries() {
            try {
                const _res_criteria_dictionaries = await this.$axios.get('/parser/dictionaries')
                this.criteriaDictionaries = _res_criteria_dictionaries.data
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorReadDefinitionANDDictionary)
            }
        },
        async getCriteriaDefinitions() {
            try {
                const _res_criteria_definitions = await this.$axios.get(`/parser/definitions/${this.sub_code}`)
                if (this.isFieldEmpty(_res_criteria_definitions.data)) {
                    this.criteriaDefinitions = []
                } else {
                    this.criteriaDefinitions = _res_criteria_definitions.data.reduce((_definitions, _definition) => {
                        const _criteria = this.criteriaDictionaries.find(_criteria_dictionary => _criteria_dictionary.id === _definition.criteria_id)
                        _definition.criteria_name = _criteria.criteria_name
                        _definitions.push(_definition)
                        return _definitions
                    }, [])
                }
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorReadDefinitionANDDictionary)
            }
        },
        async handlingErrorReadDefinitionANDDictionary(error) {
            if (error) {
                if (error.response) {
                    const { status } = error.response
                    if ([400, 403, 404].includes(status)) {
                        alert(getErrorMessage(error, '요청을 처리하지 못했습니다.'))
                    }
                } else {
                    alert('알 수 없는 error가 발생했습니다. 수정창을 닫고 다시 시도해주세요.')
                }
            }
        },
        setActivate_Picker(type) {
            if (type === 'key') {
                this.is_Activate_Picker_Key = true
                this.is_Activate_Picker_Unit = false
            } else if (type === 'unit') {
                this.is_Activate_Picker_Key = false
                this.is_Activate_Picker_Unit = true
            } else {
                // all
                this.is_Activate_Picker_Key = false
                this.is_Activate_Picker_Unit = false
            }
        },
        criteria_picker_non_element(row_index, col_idx, item_column_name, isActivated) {
            if (!isActivated) {
                return false
            }
            /**
             * pick_element_obj = { row_index, col_idx, item_text, item_column_name }
             * 
            */

            if (this.isEditorActivated) {
                if (this.is_Activate_Picker_Key) {
                    if (this.sub_type === 'radio') {
                        this.definitionForm.item_index = null
                        this.definitionForm.item_key = 'result'
                    }
                    else if (this.sub_type === 'checkbox') {
                        this.definitionForm.item_key = item_column_name

                        if (item_column_name === 'description') {
                            this.definitionForm.item_index = row_index
                        } else {
                            this.definitionForm.item_index = null
                        }
                    }
                    else if (this.sub_type === 'table') {
                        this.definitionForm.item_index = row_index
                        this.definitionForm.item_key = item_column_name
                    }

                    this.definitionForm.item_element_content_structure_index = null
                    this.definitionForm.item_element_content_index = null
                } else {
                    if (this.sub_type === 'radio') {
                        this.definitionForm.unit_index = null
                        this.definitionForm.unit_key = null
                    }
                    else if (this.sub_type === 'checkbox') {
                        this.definitionForm.unit_index = null
                        this.definitionForm.unit_key = null
                    }
                    else if (this.sub_type === 'table') {
                        this.definitionForm.unit_index = row_index
                        this.definitionForm.unit_key = item_column_name
                    }

                    if (['table', 'radio'].includes(this.sub_type)) {
                        this.definitionForm.unit_static_value = null
                    }

                    this.definitionForm.unit_element_content_structure_index = null
                    this.definitionForm.unit_element_content_index = null
                }

                this.definitionForm.type = this.sub_type
            }
        },
        criteria_picker_element(element_type, row_index, col_idx, element_row_index, element_col_idx, item_text, item_column_name, isActivated) {
            if (!isActivated) return false

            if (this.is_Activate_Picker_Key) {
                if (['input_text', 'input_number'].includes(element_type)) {
                    this.definitionForm.item_index = row_index // 측정항목 Structure Index
                    this.definitionForm.item_key = 'result'
                    this.definitionForm.item_element_content_structure_index = null
                    this.definitionForm.item_element_content_index = element_row_index
                }
                else if (element_type === 'table') {
                    this.definitionForm.item_key = item_column_name
                    this.definitionForm.item_index = row_index // 측정항목 Structure Index
                    this.definitionForm.item_element_content_structure_index = element_row_index
                    this.definitionForm.item_element_content_index = element_col_idx
                }
                else if (element_type === 'checkbox') {
                    this.definitionForm.item_index = row_index // 측정항목 Structure Index
                    if (item_column_name === 'description') {
                        this.definitionForm.item_key = 'description'
                        this.definitionForm.item_index = row_index
                        this.definitionForm.item_element_content_structure_index = element_row_index
                        this.definitionForm.item_element_content_index = element_col_idx
                    } else {
                        this.definitionForm.item_key = 'result'
                        this.definitionForm.item_element_content_structure_index = null
                        this.definitionForm.item_element_content_index = element_row_index
                    }

                    this.definitionForm.unit_index = null // 단위 Unit Structure Index
                    this.definitionForm.unit_element_content_structure_index = null
                    this.definitionForm.unit_element_content_index = null

                    /**
                     * Case Handling - Checkbox Element
                     * checkbox Element는 unit으로 특별히 선택되거나 입력되지 않는 경우,
                     * Uit Picker가 작동되지 않기 때문에 Key Picker에서 미리 지정해둬야함.
                     */
                }
            } else {
                if (['input_text', 'input_number'].includes(element_type)) {
                    this.definitionForm.unit_index = null // 단위 Unit Structure Index
                    this.definitionForm.unit_element_content_structure_index = null
                    this.definitionForm.unit_element_content_index = null
                    this.definitionForm.unit_key = element_type === 'input_number' ? item_column_name : null
                } else if (element_type === 'table') {
                    this.definitionForm.unit_index = row_index // 단위 Unit Structure Index
                    this.definitionForm.unit_element_content_structure_index = element_row_index
                    this.definitionForm.unit_element_content_index = element_col_idx
                    this.definitionForm.unit_key = item_column_name
                } else if (element_type === 'checkbox') {
                    this.definitionForm.unit_index = row_index // 단위 Unit Structure Index
                    this.definitionForm.unit_element_content_structure_index = null
                    this.definitionForm.unit_element_content_index = null
                    this.definitionForm.unit_key = null
                }

                // handling the 'unit_static_value' variable
                if (element_type === 'input_number' && this.definitionForm.unit_key && this.definitionForm.unit_static_value && this.definitionForm.unit_static_value !== '') {
                    return alert('input_number 타입의 subs의 "단위"를 직접 입력 또는 선택한 단위 중 한가지만 입력해주세요.')
                }

                if (['table', 'radio'].includes(element_type)) {
                    this.definitionForm.unit_static_value = null
                }
            }

            this.definitionForm.type = element_type
        },
        async onCreateCriteriaDefinition() {
            let is_created = false
            try {

                /**
                 * 생성 API가 완료되면 기능 테스트 이후에 본 메서드 제일 하단에 axios 코드를 활성화시켜 연결
                 * 백엔드에서 type, source_code 필드값이 정해졌다면 formData에도 추가해줘야함
                 */

                /**
                 * this.definitionForm.item_key
                 * this.definitionForm.item_element_content_structure_index
                 * this.definitionForm.item_element_content_index
                 * this.definitionForm.unit_index
                 * this.definitionForm.unit_key
                 * this.definitionForm.unit_element_content_structure_index
                 * this.definitionForm.unit_element_content_index
                 * this.definitionForm.unit_static_value
                 * this.definitionForm.item_index
                 * this.definitionForm.year
                 */


                this.is_create_criteria_definition = true

                if (this.definitionForm.type === 'input_number' && this.definitionForm.unit_key && this.definitionForm.unit_static_value && this.definitionForm.unit_static_value !== '') {
                    alert('input_number 타입의 subs의 "단위"를 직접 입력 또는 선택한 단위 중 한가지만 입력해주세요.')
                    return false
                }

                if (this.definitionForm.unit_static_value === '') {
                    this.definitionForm.unit_static_value = null
                }

                // const formData = new FormData()
                const newDefinition = {}
                if (this.definitionForm.id) {
                    newDefinition.definition_id = this.definitionForm.id
                }

                newDefinition.criteria_id = this.definitionForm.item_selected
                newDefinition.key = this.definitionForm.item_key

                if (this.checkCriterialFormFieldValidation(this.definitionForm.item_index)) {
                    newDefinition.structure_idx = this.definitionForm.item_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.item_element_content_index)) {
                    newDefinition.element_idx = this.definitionForm.item_element_content_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.item_element_content_structure_index)) {
                    newDefinition.element_str_idx = this.definitionForm.item_element_content_structure_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.unit_index)) {
                    let _dismiss_index = this.definitionForm.item_index !== this.definitionForm.unit_index
                    if (_dismiss_index) {
                        const _dismiss_index_confirm = confirm("점수를 산출할 문항의 '구분'과 '단위'를 다르게 설정하셨습니다. 그대로 진행하시겠습니까?")
                        if (!_dismiss_index_confirm) {
                            this.definitionForm.unit_index = this.definitionForm.item_index
                        }
                    }

                    newDefinition.unit_structure_idx = this.definitionForm.unit_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.unit_element_content_index)) {
                    let _dismiss_element_index = this.definitionForm.item_element_content_index !== this.definitionForm.unit_element_content_index
                    if (_dismiss_element_index) {
                        const _dismiss_element_index_confirm = confirm("점수를 산출할 세부 문항의 '구분'과 '단위'를 다르게 설정하셨습니다. 그대로 진행하시겠습니까?")
                        if (!_dismiss_element_index_confirm) {
                            this.definitionForm.unit_element_content_index = this.definitionForm.item_element_content_index
                        }
                    }

                    newDefinition.unit_element_idx = this.definitionForm.unit_element_content_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.unit_element_content_structure_index)) {
                    let _dismiss_element_content_structure_index = this.definitionForm.item_element_content_structure_index !== this.definitionForm.unit_element_content_structure_index
                    if (_dismiss_element_content_structure_index) {
                        const _dismiss_element_content_structure_index_confirm = confirm("점수를 산출할 세부 문항의 '구분'과 '단위'를 다르게 설정하셨습니다. 그대로 진행하시겠습니까?")
                        if (!_dismiss_element_content_structure_index_confirm) {
                            this.definitionForm.unit_element_content_structure_index = this.definitionForm.item_element_content_structure_index
                        }
                    }

                    newDefinition.unit_element_str_idx = this.definitionForm.unit_element_content_structure_index
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.unit_key)) {
                    newDefinition.unit_key = this.definitionForm.unit_key
                }

                if (this.checkCriterialFormFieldValidation(this.definitionForm.unit_static_value)) {
                    newDefinition.unit_static_value = this.definitionForm.unit_static_value
                }

                if (!/^\d{4}$/.test(String(this.definitionForm.year))) {
                    alert('입력된 연도가 틀렸습니다.')
                    return false
                }

                if (!/^\d{4}$/.test(String(this.definitionForm.collection_year))) {
                    alert('입력된 데이터 수집 연도가 틀렸습니다.')
                    return false
                }

                newDefinition.year = this.definitionForm.year
                newDefinition.collection_year = this.definitionForm.collection_year

                // handling the 'unit_static_value' variable
                if (this.sub_type === 'table' || this.sub_type === 'radio') {
                    this.unit_static_value = null
                }

                newDefinition.type = this.definitionForm.measure_type
                newDefinition.source_code = 'AS'
                newDefinition.sub_code = this.sub_code

                await this.$axios.post(`/parser/definitions/${this.sub_code}`, newDefinition)
                is_created = true
            } catch (error) {
                await this.common_error_handling(error, this.handlingErrorCreateCriteriaDefinition)
            } finally {
                // 검증 실패/오류 때는 입력한 폼을 유지한다
                if (is_created) this.onResetParser()
                await this.getCriteriaDefinitions()
                this.is_create_criteria_definition = false
            }
        },
        async handlingErrorCreateCriteriaDefinition(error) {
            if (error) {
                if (error.response) {
                    const { status } = error.response
                    if ([400, 404, 403].includes(status)) {
                        alert(getErrorMessage(error, '요청을 처리하지 못했습니다.'))
                        await this.getCriteriaDictionaries()
                    } else if (status !== 401) {
                        alert(getErrorMessage(error, '요청을 처리하지 못했습니다. 잠시 후 다시 시도해주세요.'))
                    }
                } else {
                    alert('알 수 없는 error가 발생했습니다. Subs 수정창을 닫고 다시 시도해주세요.')
                }
            }
        },
        editCriteriaDefinition(index, definition_id) {
            const _edit_target_definition = this.criteriaDefinitions.find(_definition => _definition.definition_id === definition_id)
            if (!_edit_target_definition) {
                alert('알 수 없는 Criteria 입니다! 모달창을 껏다 다시 켠후 수정해주세요')
            } else {
                this.is_Activate_Picker_Key = true,
                    this.is_Activate_Picker_Unit = false
                this.isEditorActivated = false

                this.definitionForm = {
                    id: _edit_target_definition.definition_id,
                    type: null, // 'table', 'radio', 'checkbox', 'input_text', 'input_number'
                    item_selected: _edit_target_definition.criteria_id,
                    item_index: _edit_target_definition.index, // 측정항목 Structure Index
                    item_key: _edit_target_definition.key,
                    item_element_content_structure_index: _edit_target_definition.element_str_idx,
                    item_element_content_index: _edit_target_definition.element_idx,
                    unit_index: _edit_target_definition.unit_structure_idx, // 단위 Unit Structure Index
                    unit_key: _edit_target_definition.unit_key,
                    unit_static_value: _edit_target_definition.unit_static_value,
                    unit_element_content_structure_index: _edit_target_definition.unit_element_str_idx,
                    unit_element_content_index: _edit_target_definition.unit_element_idx,
                    year: _edit_target_definition.year,
                    collection_year: _edit_target_definition.collection_year,
                    measure_type: _edit_target_definition.type
                }

                this.isEditorActivated = true
            }
        },
        async deleteCriteriaDefinition(definition_id, record) {
            try {

                /**
                 * delete API 기능 개발이 완료되면 마지막 axios 호출 부분을 활성화 시켜서 기능 테스트
                 */

                this.is_delete_criteria_definition = true
                this.delete_criteria_definition_target = definition_id
                const _delete_target_definition = this.criteriaDefinitions.find(_definition => _definition.definition_id === definition_id)
                if (!_delete_target_definition) {
                    alert('알 수 없는 Criteria 입니다! 모달창을 껏다 다시 켠후 삭제해주세요')
                    return false
                } else {
                    const _confirmed = await this.$showModal({
                        type: 'confirm',
                        state: 'warning',
                        title: 'Criteria 정의 삭제',
                        message: `문항 ${this.sub_code} 의 Criteria 정의(definition_id: ${definition_id})를 삭제합니다. 되돌릴 수 없습니다.`
                    })
                    if (!_confirmed) return false
                    await this.$axios.delete(`/parser/definitions/${this.sub_code}`, { data: { definition_id } })
                }
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    await this.commonLogout()
                } else {
                    alert(getErrorMessage(error, '삭제하지 못했습니다. 잠시 후 다시 시도해주세요.'))
                }
            } finally {
                await this.getCriteriaDefinitions()
                this.is_delete_criteria_definition = false
                this.delete_criteria_definition_target = null
            }
        },
        onResetParser() {
            this.setActivate_Picker()
            this.definitionForm = {
                id: null,
                type: null, // 'table', 'radio', 'checkbox', 'input_text', 'input_number'
                item_selected: null,
                item_index: null, // 측정항목 Structure Index
                item_key: null,
                item_element_content_structure_index: null,
                item_element_content_index: null,
                unit_index: null, // 단위 Unit Structure Index
                unit_key: null,
                unit_static_value: null,
                unit_element_content_structure_index: null,
                unit_element_content_index: null,
                year: new Date().getFullYear(),
                collection_year: new Date().getFullYear()
            }

            this.is_Activate_Picker_Key = true
            this.is_Activate_Picker_Unit = false
            this.isEditorActivated = false
            this.activateAllClickableArea = false
        },
        checkCriterialFormFieldValidation(_value) {
            return ![null, '', ' '].includes(_value)
        },
        async parseCriteriaDefinition() {
            let _is_parsing_criteriaDefinition_success = true
            try {
                this.is_parsing_criteriaDefinition.progress = true

                if (this.criteriaDefinitions.length) {
                    const parsingDefinitionFormData = new FormData()
                    if (this.sub_code) parsingDefinitionFormData.append('sub_code', this.sub_code)
                    await this.$axios.post('/parser/values', parsingDefinitionFormData)
                }

                _is_parsing_criteriaDefinition_success = true
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 401) {
                        await this.commonLogout()
                    }
                }

                _is_parsing_criteriaDefinition_success = false
            } finally {
                this.is_parsing_criteriaDefinition = {
                    progress: false,
                    success: _is_parsing_criteriaDefinition_success
                }

                setTimeout(() => {
                    this.is_parsing_criteriaDefinition = {
                        progress: false,
                        success: null
                    }
                }, 1500);
            }
        },
    }
}
</script>

<style></style>
